
const TIPO = 'tipo';
const CLASIFICACION = 'clasificacion';
const GRUPO = 'grupo';
const MODELO = 'modelo';
const NIVEL = 'nivel';
const OPERADOR = 'operador';
const PERSONA = 'persona';

export default {
  TIPO,
  CLASIFICACION,
  GRUPO,
  MODELO,
  NIVEL,
  OPERADOR,
  PERSONA,
};
